<template>
    <div>
        <section class="section-fixed-prognav">
        <div class="flow-nav-wrap">
            <div class="checkout-flow-nav-div">
                <div class="div-block-2252">
                    <div class="text-block-1727">Call us</div>
                    <a :href="supportPhoneTel" class="link-90">+1 {{ supportPhone }}</a>
                </div>
                <a href="#" class="link-block-33 w-inline-block"><img sizes="236.8229217529297px" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" src="@/assets/images/NewSelf_Logo.webp" loading="lazy" class="image-378 logo-nav"></a>
                <div class="div-block-2253" v-if="active_el>1">
                    <a href="#" class="link-block-109 desktop-back w-inline-block" @click.prevent="goBack"><img src="@/assets/images/back_arrow.png" loading="lazy" alt="" class="image-692"></a>
                </div>
                <div class="mobile-nav-links">
                    <a href="#" class="link-block-109 w-inline-block" v-if="active_el>1" @click.prevent="goBack"><img src="@/assets/images/back_arrow.png" loading="lazy" alt="" class="image-692"></a>
                </div>
            </div>
        </div>
        <div class="checkout-flow-prog-div">
            <div class="quiz-progress-div">
                <div class="progress"></div>
            </div>
        </div>
    </section>
        <div v-if="validatingAddress" class="loading-overlay2">
            <div class="">
                <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                    <circle cx="50" cy="50" fill="none" stroke="#e9ff86" stroke-width="10" r="35" stroke-dasharray="165 57">
                        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                    </circle>
                </svg>
            </div>
        </div>
        <section class="afterreport_section">
            <div class="questions-div">
                <!-- Address Verification Step -->
                <div class="question-container" v-if="active_el === 0">
                    <div class="question-div-2">
                        <div class="text-block-513 hq">Verify your shipping address</div>
                        <div class="form-subs">We need to confirm your shipping address to ensure accurate delivery of your medications.</div>
                        
                        <!-- Address Validation Loading State -->
                        <div v-if="validatingAddress" class="validation-loading">
                            <div>Validating your address...</div>
                        </div>
                        <!-- Address Invalid - Show Suggestions -->
                        <div v-else-if="!addressValid && addressSuggestions" class="address-suggestions">
                            <div class="suggestion-header">We found a suggested correction for your address:</div>
                            <div class="suggested-address">
                                <div><strong>Suggested Address:</strong></div>
                                <div>{{ addressSuggestions.address_line_1 }}</div>
                                <div v-if="addressSuggestions.address_line_2">{{ addressSuggestions.address_line_2 }}</div>
                                <div>{{ addressSuggestions.city }}, {{ addressSuggestions.state }} {{ addressSuggestions.zip }}</div>
                            </div>
                            <div class="button-group">
                                <button 
                                    type="button" 
                                    class="form-button w-button"
                                    @click="acceptSuggestedAddress"
                                    :disabled="savingAddress"
                                >
                                    {{ savingAddress ? 'Saving...' : 'Use Suggested Address' }}
                                </button>
                                <button 
                                    type="button" 
                                    class="form-button secondary w-button"
                                    @click="showAddressForm = true"
                                >
                                    Enter Different Address
                                </button>
                            </div>
                        </div>
                        
                        <!-- Manual Address Entry Form -->
                        <div v-if="showAddressForm || (!addressValid && !addressSuggestions)" class="felix-form-block w-form">
                            <form @submit.prevent="validateAndSaveAddress">
                                <div class="address-form-row">
                                    <div class="address-field">
                                        <input 
                                            class="tf_textfield-3 w-input" 
                                            v-model="addressForm.address_line_1" 
                                            maxlength="256" 
                                            name="Address-1" 
                                            placeholder="Address" 
                                            type="text" 
                                            required
                                        >
                                    </div>
                                    <div class="apt-field">
                                        <input 
                                            class="tf_textfield-3 w-input" 
                                            maxlength="256" 
                                            v-model="addressForm.address_line_2" 
                                            name="Apt-2" 
                                            placeholder="Apt #" 
                                            type="text"
                                        >
                                    </div>
                                </div>
                                <div class="address-form-row">
                                    <div class="city-field">
                                        <input 
                                            v-model="addressForm.city" 
                                            class="tf_textfield-3 w-input" 
                                            placeholder="City" 
                                            required
                                        />
                                    </div>
                                                                         <div class="state-field">
                                         <select 
                                             name="State" 
                                             required 
                                             v-model="addressForm.state"  
                                             class="tf_textfield-3 w-input"
                                         >
                                             <option value="" disabled>State</option>
                                             <option v-for="(value, key) in allState" :value="value" :key="value">{{ key }}</option>
                                         </select>
                                     </div>
                                    <div class="zip-field">
                                        <input 
                                            v-model="addressForm.zip" 
                                            placeholder="ZIP Code" 
                                            class="tf_textfield-3 w-input" 
                                            required
                                        />
                                    </div>
                                </div>
                                <input 
                                    type="submit" 
                                    class="form-button w-button" 
                                    :value="savingAddress ? 'Validating...' : 'Validate & Save Address'"
                                    :disabled="savingAddress"
                                >
                                
                                <div v-if="showAddressSuccess" class="success-message">
                                    <div>Address updated successfully!</div>
                                </div>
                                
                                <ErrorMessage 
                                    :message="errorMessage"
                                    @dismiss="clearError"
                                />
                            </form>
                        </div>
                        
                        <!-- Address Valid - Show Confirmation -->
                        <div v-if="addressValid && !showAddressForm" class="address-confirmed">
                            <div class="confirmation-header">✓ Your address has been verified</div>
                            <div class="auto-advance-message">Automatically advancing to phone verification...</div>
                        </div>
                    </div>
                    
                    
                </div>

                <!-- Phone Change Form -->
                <div class="question-container" v-if="active_el === 1 && isChangingPhone">
                    <div class="question-div-2">
                        <div class="text-block-513 hq">What is your mobile phone number?</div>
                        <div class="form-subs">Enter the best phone to reach you on just in case your doctor has any questions regarding your medical information.</div>
                        <div class="checks-div">
                            <div class="bullet-div">
                                <img loading="lazy" src="images/icon_check-black2.svg" alt="" class="image-303">
                                <div class="text-block-540">Updates from your doctor</div>
                            </div>
                            <div class="bullet-div">
                                <img loading="lazy" src="images/icon_check-black2.svg" alt="" class="image-303">
                                <div class="text-block-540">Shipping notifications</div>
                            </div>
                            <div class="bullet-div">
                                <img loading="lazy" src="images/icon_check-black2.svg" alt="" class="image-303">
                                <div class="text-block-540">Prescription alerts</div>
                            </div>
                        </div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="updatePhoneNumber">
                                <div class="phone-entry-div felix">
                                    <input 
                                        v-model="newPhone.area"
                                        ref="areaInput"  
                                        class="phone-number-field-3 _1 form w-input"
                                        maxlength="3"
                                        placeholder="(000)"
                                        type="text"
                                        autocomplete="off"
                                        @input="validatePhoneInput($event, 'area')"
                                    >
                                    <div class="text-block-539">-</div>
                                    <input 
                                        v-model="newPhone.prefix"
                                        ref="prefixInput"
                                        class="phone-number-field-3 form w-input"
                                        maxlength="3"
                                        placeholder="000"
                                        type="text"
                                        autocomplete="off"
                                        @input="validatePhoneInput($event, 'prefix')"
                                    >
                                    <div class="text-block-539">-</div>
                                    <input 
                                        v-model="newPhone.line"
                                        ref="lineInput" 
                                        class="phone-number-field-3 _2 form w-input"
                                        maxlength="4"
                                        placeholder="0000"
                                        type="text"
                                        autocomplete="off"
                                        @input="validatePhoneInput($event, 'line')"
                                    >
                                </div>
                                <div class="button-group">
                                    <input 
                                        type="submit" 
                                        class="form-button w-button" 
                                        :value="updatingPhone ? 'Updating...' : 'Update Phone Number'"
                                        :disabled="!isValidPhone || updatingPhone"
                                    >
                                </div>
                                <ErrorMessage 
                                    :message="errorMessage"
                                    @dismiss="clearError"
                                />
                            </form>
                        </div>
                    </div>
                    <div class="enroll-form-back-link-div">
                        <a href="#" @click.prevent="cancelPhoneChange()" class="enroll-form-back-link w-inline-block">
                            <div class="enroll-form-back-text">&lt; Cancel</div>
                        </a>
                    </div>
                </div>
    
                <!-- Phone Verification -->
                <div class="question-container" v-if="active_el === 1 && !isChangingPhone">
                    <div class="question-div-2">
                        <div class="text-block-513 hq">Verify your mobile phone number</div>
                        <div class="form-subs">enter the 4-digit sent to <span class="phone-number-span">{{ user.phone }}</span></div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handlePhoneVerification">
                                <div class="phone-verify-div">
                                    <input 
                                        v-for="(digit, index) in 4" 
                                        :key="index"
                                        v-model="phoneOtpDigits[index]"
                                        class="text-field-57 w-input"
                                        maxlength="1"
                                        type="text"
                                        pattern="[0-9]*" inputmode="numeric"
                                        @input="handleOtpInput($event, index, 'phone')"
                                        @keydown="handleKeydown($event, index, 'phone')"
                                        ref="phoneInputs"
                                        :disabled="verifyingPhone"
                                    >
                                </div>
                                
                                <div class="resend-section">
                                    <a 
                                        href="#" 
                                        class="link-65" 
                                        @click.prevent="resendCode('phone')"
                                        v-if="!phoneResendTimer"
                                        :class="{ 'disabled': phoneCodeSent }"
                                    >
                                        Resend code
                                    </a>
                                    <span v-else class="timer">Resend available in {{ phoneResendTimer }}s</span>
                                </div>
                                
                                <a href="#" class="link-66" @click.prevent="changePhone">Change my mobile number</a>
                                
                                <input 
                                    type="submit" 
                                    class="form-button w-button" 
                                    :value="verifyingPhone ? 'Verifying...' : 'Next →'"
                                    :disabled="!isPhoneOtpComplete || verifyingPhone"
                                >
                                <ErrorMessage 
                                    :message="errorMessage"
                                    @dismiss="clearError"
                                />
                            </form>
                        </div>
                    </div>
                    <div class="enroll-form-back-link-div">
                        <a href="#" @click.prevent="skipPhoneVerification()" class="enroll-form-back-link w-inline-block">
                            <div class="enroll-form-back-text">Skip verification -></div>
                        </a>
                    </div>
                </div>
    
                <!-- Email Change Form -->
                <div class="question-container" v-if="active_el === 2 && isChangingEmail">
                    <div class="question-div-2">
                        <div class="text-block-513 hq">Update your email address</div>
                        <div class="form-subs">Enter your new email address to receive important updates and notifications.</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="updateEmailAddress">
                                <div class="email-entry-div">
                                    <input 
                                        v-model="newEmail"
                                        class="text-field-33 email form update w-input"
                                        type="email"
                                        placeholder="Enter your email address"
                                        required
                                    >
                                </div>
                                <div class="button-group">
                                    <input 
                                        type="submit" 
                                        class="form-button w-button" 
                                        :value="updatingEmail ? 'Updating...' : 'Update Email Address'"
                                        :disabled="!isValidEmail || updatingEmail"
                                    >
                                </div>
                                <ErrorMessage 
                                    :message="errorMessage"
                                    @dismiss="clearError"
                                />
                            </form>
                        </div>
                    </div>
                    <div class="enroll-form-back-link-div">
                        <a href="#" @click.prevent="cancelEmailChange()" class="enroll-form-back-link w-inline-block">
                            <div class="enroll-form-back-text">&lt; Cancel</div>
                        </a>
                    </div>
                </div>
    
                <!-- Email Verification -->
                <div class="question-container" v-if="active_el === 2 && !isChangingEmail">
                    <div class="question-div-2">
                        <div class="text-block-513 hq">Verify your email address</div>
                        <div class="form-subs">enter the 4-digit sent to <span class="phone-number-span">{{ user.email }}</span></div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleEmailVerification">
                                <div class="phone-verify-div">
                                    <input 
                                        v-for="(digit, index) in 4" 
                                        :key="index"
                                        v-model="emailOtpDigits[index]"
                                        class="text-field-57 w-input"
                                        maxlength="1"
                                        type="text"
                                        pattern="[0-9]*" inputmode="numeric"
                                        @input="handleOtpInput($event, index, 'email')"
                                        @keydown="handleKeydown($event, index, 'email')"
                                        ref="emailInputs"
                                        :disabled="verifyingEmail"
                                    >
                                </div>
                                
                                <div class="resend-section">
                                    <a 
                                        href="#" 
                                        class="link-65" 
                                        @click.prevent="resendCode('email')"
                                        v-if="!emailResendTimer"
                                        :class="{ 'disabled': emailCodeSent }"
                                    >
                                        Resend code
                                    </a>
                                    <span v-else class="timer">Resend available in {{ emailResendTimer }}s</span>
                                </div>
                                
                                <a href="#" class="link-66" @click.prevent="changeEmail">Change my email address</a>
                                
                                <input 
                                    type="submit" 
                                    class="form-button w-button" 
                                    :value="verifyingEmail ? 'Verifying...' : 'Next →'"
                                    :disabled="!isEmailOtpComplete || verifyingEmail"
                                >
                                <ErrorMessage 
                                    :message="errorMessage"
                                    @dismiss="clearError"
                                />
                            </form>
                        </div>
                    </div>
                    <div class="enroll-form-back-link-div">
                        <a href="#" @click.prevent="skipEmailVerification()" class="enroll-form-back-link w-inline-block">
                            <div class="enroll-form-back-text">Skip verification -></div>
                        </a>
                    </div>
                </div>
            </div>
        </section>
        <div style="height:280px"></div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ErrorMessage from './ErrorMessage.vue';
import state from "@/utils/state.json"
export default {
    name: 'VerifyPhoneAndEmail',
    props: ['baseUrl'],
    components: {
        ErrorMessage
    },
    data() {
        return {
            errorMessage: '',
            active_el: 0, // Start with address verification (step 0)
            phoneOtpDigits: ['', '', '', ''],
            emailOtpDigits: ['', '', '', ''],
            phoneResendTimer: 0,
            emailResendTimer: 0,
            phoneCodeSent: false,
            emailCodeSent: false,
            verifyingPhone: false,
            verifyingEmail: false,
            phoneTimerId: null,
            emailTimerId: null,
            isChangingPhone: false,
            isChangingEmail: false,
            updatingPhone: false,
            updatingEmail: false,
            newPhone: {
                area: '',
                prefix: '',
                line: ''
            },
            newEmail: '',
            phoneAttempts: 0,
            emailAttempts: 0,
            phoneCodesSent: 0, 
            validatingAddress: false, // Loading state when validating address
            addressValid: false, // Whether current address is valid
            addressSuggestions: null, // Suggestions from API if address is invalid
            showAddressForm: false, // Whether to show the manual address entry form
            savingAddress: false, // Loading state when saving address
            showAddressSuccess: false, // Success message for address update
            addressForm: { // Form data for address entry
                address_line_1: '',
                address_line_2: '',
                city: '',
                state: '',
                zip: ''
            },
            allState: state
        }
    },
    computed: {
        ...mapGetters(['getRemainingPrescriptions','user','getShippingAddress']),
        remainingPrescriptions() {
            return this.getRemainingPrescriptions;
        },
        isPhoneOtpComplete() {
            return this.phoneOtpDigits.every(digit => digit.length === 1);
        },
        isEmailOtpComplete() {
            return this.emailOtpDigits.every(digit => digit.length === 1);
        },
        isValidPhone() {
            const { area, prefix, line } = this.newPhone;
            
            // Check lengths
            if (area.length !== 3 || prefix.length !== 3 || line.length !== 4) {
                return false;
            }

            // Check if all parts are numbers
            if (!/^\d+$/.test(area) || !/^\d+$/.test(prefix) || !/^\d+$/.test(line)) {
                return false;
            }

            // Check for valid area code
            if (area === '000' || area === '911' || area.startsWith('0') || area.startsWith('1')) {
                return false;
            }

            // Check for valid prefix
            if (prefix === '000' || prefix === '911' || prefix.startsWith('0') || prefix.startsWith('1')) {
                return false;
            }

            // Check for valid line number
            if (line === '0000' || line === '9111') {
                return false;
            }

            return true;
        },
        isValidEmail() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(this.newEmail);
        }
    },
    methods: {
        clearError() {
            this.errorMessage = '';
        },

        goBack() {
            if (this.active_el > 1) {
                this.active_el = this.active_el - 1;
            }
        },

                 setAddressFromStrore(){
             try{
                 this.addressForm.address_line_1 = this.getShippingAddress.addressLine1 || '';
                 this.addressForm.address_line_2 = this.getShippingAddress.addressLine2 || '';
                 this.addressForm.city = this.getShippingAddress.city || '';
                 this.addressForm.state = this.getShippingAddress.state || '';
                 this.addressForm.zip = this.getShippingAddress.zip || '';
             }catch(error){
                 console.log(error)
             }
         },
        async validateUserAddress() {
            this.validatingAddress = true;
            this.errorMessage = '';
            
            try {
                const response = await this.$axios.get(`${this.baseUrl}/api/address/validate/${this.user.id}`);
                
                if (response.data.valid) {
                    this.addressValid = response.data.valid;
                    if (response.data.valid) {
                        this.moveToPhoneVerification();
                    } else if (response.data.suggestions) {
                        // Address is invalid but we have suggestions
                        this.addressSuggestions = response.data.suggestions;
                    }
                } else {
                    // API call failed
                    this.errorMessage = 'Unable to validate address. Please enter your address manually.';
                    this.showAddressForm = true;
                }
            } catch (error) {
                console.error('Error validating address:', error);
                this.errorMessage = 'Unable to validate address. Please enter your address manually.';
                this.showAddressForm = true;
            } finally {
                this.validatingAddress = false;
            }
        },

        /**
         * Accepts the suggested address from the API and saves it
         * Reasoning: Allows users to quickly accept the corrected address without manual entry
         * Changes: Streamlines the address correction process and auto-advances to next step
         */
        async acceptSuggestedAddress() {
            this.savingAddress = true;
            this.errorMessage = '';
            
            try {
                // Save the suggested address
                const response = await this.$axios.post(`${this.baseUrl}/api/ship-address`, this.addressSuggestions);
                
                if (response.data.status === 'success') {
                    // Update store with the new address
                    await this.$store.dispatch('saveShippingDetails', this.addressSuggestions);
                    this.addressValid = true;
                    
                    // Auto-advance to phone verification immediately
                    this.moveToPhoneVerification();
                } else {
                    this.errorMessage = 'Failed to save address. Please try again.';
                }
            } catch (error) {
                console.error('Error saving suggested address:', error);
                this.errorMessage = error.response?.data?.message || 'Failed to save address. Please try again.';
            } finally {
                this.savingAddress = false;
            }
        },

        /**
         * Validates and saves manually entered address
         * Reasoning: Validates the user's manually entered address before saving to ensure accuracy
         * Changes: Adds validation step before saving to prevent invalid addresses from being stored, auto-advances when successful
         */
        async validateAndSaveAddress() {
            this.savingAddress = true;
            this.errorMessage = '';
            
            try {
                // First validate the entered address
                const validationResponse = await this.$axios.post(`${this.baseUrl}/api/address/validate`, this.addressForm);
                
                if (validationResponse.data.valid) {
                    // Address is valid, save it
                    const saveResponse = await this.$axios.post(`${this.baseUrl}/api/ship-address`, this.addressForm);
                    
                    if (saveResponse.data.status === 'success') {
                        await this.$store.dispatch('saveShippingDetails', this.addressForm);
                        this.addressValid = true;
                        this.showAddressForm = false;
                        
                        // Auto-advance to phone verification immediately
                        this.moveToPhoneVerification();
                    } else {
                        this.errorMessage = 'Failed to save address. Please try again.';
                    }
                } else if (validationResponse.data.suggestions) {
                    // Address is invalid but we have suggestions
                    this.addressSuggestions = validationResponse.data.suggestions;
                    this.showAddressForm = false;
                    this.errorMessage = 'We found a suggested correction for your address.';
                } else {
                    // Address is invalid and no suggestions
                    this.errorMessage = 'Please check your address and try again.';
                }
            } catch (error) {
                console.error('Error validating/saving address:', error);
                this.errorMessage = error.response?.data?.message || 'Failed to validate address. Please try again.';
            } finally {
                this.savingAddress = false;
            }
        },

        /**
         * Moves to phone verification step
         * Reasoning: Provides smooth transition from address verification to phone verification
         * Changes: Updates the active step and initiates phone verification process
         */
        moveToPhoneVerification() {
            this.active_el = 1;
            // Send initial phone verification code when moving to phone step
            this.sendCode('phone');
        },

        /**
         * Skips address verification and moves to phone verification
         * Reasoning: Allows users to skip address verification if they choose to
         * Changes: Provides option to bypass address verification while maintaining flow
         */
        skipAddressVerification() {
            this.moveToPhoneVerification();
        },

        // Keeping all existing phone and email methods unchanged as per user request
        // Just commenting them out as instructed but preserving functionality

        handleOtpInput(event, index, type) {
            const value = event.target.value;
            const digits = type === 'phone' ? this.phoneOtpDigits : this.emailOtpDigits;
            const inputs = type === 'phone' ? this.$refs.phoneInputs : this.$refs.emailInputs;
            
            // Only allow numbers
            if (!/^\d*$/.test(value)) {
                digits[index] = '';
                return;
            }

            // Auto-advance to next input
            if (value && index < 3) {
                inputs[index + 1].focus();
            }
        },

        handleKeydown(event, index, type) {
            const digits = type === 'phone' ? this.phoneOtpDigits : this.emailOtpDigits;
            const inputs = type === 'phone' ? this.$refs.phoneInputs : this.$refs.emailInputs;

            if (event.key === 'Backspace' && !digits[index] && index > 0) {
                digits[index - 1] = '';
                inputs[index - 1].focus();
            }
        },

        validatePhoneInput(event, field) {
            let value = event.target.value.replace(/\D/g, '');
            // Area code never starts with 1: allow a lone leading "1" but drop it once a 2nd digit lands
            if (field === 'area' && value.length > 1 && value.charAt(0) === '1') {
                value = value.slice(1);
            }
            this.newPhone[field] = value;
            
            // Auto-advance to next field when current field is complete
            const input = event.target;
            if (value.length === input.maxLength) {
                if (field === 'area') {
                    this.$refs.prefixInput.focus();
                } else if (field === 'prefix') {
                    this.$refs.lineInput.focus();
                }
            }
        },

        startResendTimer(type) {
            const timerProp = type === 'phone' ? 'phoneResendTimer' : 'emailResendTimer';
            const timerIdProp = type === 'phone' ? 'phoneTimerId' : 'emailTimerId';
            
            this[timerProp] = 60;
            
            if (this[timerIdProp]) {
                clearInterval(this[timerIdProp]);
            }

            this[timerIdProp] = setInterval(() => {
                if (this[timerProp] > 0) {
                    this[timerProp]--;
                } else {
                    clearInterval(this[timerIdProp]);
                }
            }, 1000);
        },

        async resendCode(type) {
            if ((type === 'phone' && this.phoneResendTimer > 0) || 
                (type === 'email' && this.emailResendTimer > 0)) {
                return;
            }

            try {
                await this.sendCode(type);
                this.startResendTimer(type);
                
                if (type === 'phone') {
                    this.phoneCodeSent = true;
                    this.phoneCodesSent++; // Increment counter for phone codes sent
                    
                    // Move to email verification after 2 phone codes sent
                    if (this.phoneCodesSent >= 2) {
                        this.moveToEmailVerification();
                    }
                } else {
                    this.emailCodeSent = true;
                }
            } catch (error) {
                console.error('Error resending code:', error);
                this.errorMessage = error.response?.data?.message || 'Error sending code. Please try again.';
            }
        },

        async handlePhoneVerification() {
            if (!this.isPhoneOtpComplete || this.verifyingPhone) return;
            
            this.verifyingPhone = true;
            this.errorMessage = ''; // Clear any existing error
            try {
                const code = this.phoneOtpDigits.join('');
                await this.verifyCode('phone', code);
                this.phoneAttempts = 0; // Reset attempts on success
                this.moveToEmailVerification();
            } catch (error) {
                console.error('Error verifying phone:', error);
                this.phoneAttempts++;
                this.errorMessage = error.response?.data?.message || 'Invalid verification code. Please try again.';
                // Reset OTP fields on error
                this.phoneOtpDigits = ['', '', '', ''];
                
                // Move to email verification after 2 failed attempts
                if (this.phoneAttempts >= 2) {
                    this.moveToEmailVerification();
                }
            } finally {
                this.verifyingPhone = false;
            }
        },

        moveToEmailVerification() {
            this.active_el = 2; // Move to email verification
            this.sendCode('email'); // Send email verification code
        },

        async handleEmailVerification() {
            if (!this.isEmailOtpComplete || this.verifyingEmail) return;
            
            this.verifyingEmail = true;
            this.errorMessage = ''; // Clear any existing error
            try {
                const code = this.emailOtpDigits.join('');
                await this.verifyCode('email', code);
                this.emailAttempts = 0; 
                this.pushToMedForm();
            } catch (error) {
                this.emailAttempts++;
                this.errorMessage = error.response?.data?.message || 'Invalid verification code. Please try again.';
                this.emailOtpDigits = ['', '', '', ''];
                
                // Redirect to home after 2 failed email verification attempts
                if (this.emailAttempts >= 2) {
                    this.redirectToHome();
                }
            } finally {
                this.verifyingEmail = false;
            }
        },
        
        pushToMedForm() {
            try {
                let order = this.remainingPrescriptions[0];
                console.log(order);
                this.$router.push({
                    name: 'QuestionFormLoaderUpdated',
                    params: {
                        id: order.orderId
                    }
                });
            } catch(error) {
                this.redirectToHome();
            }
        },
        
        redirectToHome() {
            window.location.href="/home"
        },
        
        skipPhoneVerification() {
            this.moveToEmailVerification();
        },
        
        skipEmailVerification() {
            this.redirectToHome();
        },
        
        changePhone() {
            this.isChangingPhone = true;
            this.phoneAttempts = 0;
            this.phoneOtpDigits = ['', '', '', ''];
            this.errorMessage = '';
            if (this.phoneTimerId) {
                clearInterval(this.phoneTimerId);
                this.phoneResendTimer = 0;
            }
        },

        changeEmail() {
            this.isChangingEmail = true;
            this.emailAttempts = 0;
            this.emailOtpDigits = ['', '', '', ''];
            this.errorMessage = '';
            if (this.emailTimerId) {
                clearInterval(this.emailTimerId);
                this.emailResendTimer = 0;
            }
        },

        cancelPhoneChange() {
            this.isChangingPhone = false;
            this.newPhone = { area: '', prefix: '', line: '' };
            this.errorMessage = '';
        },

        cancelEmailChange() {
            this.isChangingEmail = false;
            this.newEmail = '';
            this.errorMessage = '';
        },

        async updatePhoneNumber() {
            if (!this.isValidPhone || this.updatingPhone) return;
            
            this.updatingPhone = true;
            this.errorMessage = ''; // Clear any existing error
            try {
                const formattedPhone = `${this.newPhone.area}${this.newPhone.prefix}${this.newPhone.line}`;
                await this.$axios.post(`${this.baseUrl}/api/update-phone`, {
                    phone: formattedPhone
                });
                
                // Update the store with new phone number
                await this.$store.dispatch('updateUserPhone', formattedPhone);
                
                // Reset and start verification process
                this.isChangingPhone = false;
                this.phoneOtpDigits = ['', '', '', ''];
                await this.sendCode('phone');
            } catch (error) {
                console.error('Error updating phone:', error);
                this.errorMessage = error.response?.data?.message || 'Error updating phone number. Please try again.';
            } finally {
                this.updatingPhone = false;
            }
        },

        async updateEmailAddress() {
            if (!this.isValidEmail || this.updatingEmail) return;
            
            this.updatingEmail = true;
            this.errorMessage = ''; // Clear any existing error
            try {
                await this.$axios.post(`${this.baseUrl}/api/update-email`, {
                    email: this.newEmail
                });
                
                // Update the store with new email
                await this.$store.dispatch('updateUserEmail', this.newEmail);
                
                // Reset and start verification process
                this.isChangingEmail = false;
                this.emailOtpDigits = ['', '', '', ''];
                await this.sendCode('email');
            } catch (error) {
                console.error('Error updating email:', error);
                this.errorMessage = error.response?.data?.message || 'Error updating email address. Please try again.';
            } finally {
                this.updatingEmail = false;
            }
        },

        async sendCode(type) {
            this.errorMessage = ''; // Clear any existing error
            try {
                const typeValue = type === 'phone' ? 1 : 2;
                await this.$axios.post(`${this.baseUrl}/api/send-code/${typeValue}`);
                
                // Increment phone codes counter if sending phone code
                if (type === 'phone') {
                    this.phoneCodesSent++;
                    
                    // Move to email verification after 2 phone codes sent
                    if (this.phoneCodesSent >= 2) {
                        this.moveToEmailVerification();
                    }
                }
            } catch (error) {
                console.error('Error sending code:', error);
                this.errorMessage = error.response?.data?.message || 'Error sending verification code. Please try again.';
                throw error;
            }
        },

        async verifyCode(type, code) {
            this.errorMessage = ''; // Clear any existing error
            try {
                const typeValue = type === 'phone' ? 1 : 2;
                await this.$axios.post(`${this.baseUrl}/api/verify-code`, {
                    type: typeValue,
                    code
                });
            } catch (error) {
                console.error('Error verifying code:', error);
                this.errorMessage = error.response?.data?.message || 'Error verifying code. Please try again.';
                throw error;
            }
        }
    },
    /**
     * Component lifecycle - mounted
     * Reasoning: Initiates address verification when component loads instead of phone verification
     * Changes: Starting with address verification (step 0) instead of phone verification (step 1)
     */
    mounted() {
        // Start with address verification instead of phone verification
        this.setAddressFromStrore();
        this.validateUserAddress();
    },
    beforeDestroy() {
        // Clear any running timers
        if (this.phoneTimerId) clearInterval(this.phoneTimerId);
        if (this.emailTimerId) clearInterval(this.emailTimerId);
    }
}
</script>

<style scoped>
.error-message {
    margin-top: 8px;
    margin-bottom: 8px;
    padding: 10px;
    background-color: #FEE2E2;
    border: 1px solid #FCA5A5;
    color: #DC2626;
    border-radius: 4px;
    font-size: 14px;
}

/* Address verification specific styles */
.validation-loading {
    text-align: center;
    padding: 20px;
    font-size: 16px;
    color: #666;
}

.address-suggestions {
    background-color: #F3F4F6;
    border: 1px solid #D1D5DB;
    border-radius: 8px;
    padding: 20px;
    margin: 20px 0;
}

.suggestion-header {
    font-weight: bold;
    margin-bottom: 10px;
    color: #374151;
}

.suggested-address {
    background-color: white;
    border: 1px solid #E5E7EB;
    border-radius: 4px;
    padding: 15px;
    margin: 20px 0;
    line-height: 1.5;
}

.address-confirmed {
    text-align: center;
    padding: 20px;
}

.confirmation-header {
    font-size: 18px;
    font-weight: bold;
    color: #059669;
    margin-bottom: 15px;
}

.address-form-row {
    display: flex;
    gap: 10px;
    margin-bottom: 15px;
    align-items: center;
}

.address-field {
    flex: 2;
}

.apt-field {
    flex: 1;
}

.city-field {
    flex: 1;
}

.state-field {
    flex: 1;
}

.zip-field {
    flex: 1;
}

.button-group {
    display: flex;
    gap: 15px;
    margin-top: 20px;
    flex-wrap: wrap;
}

.form-button.secondary {
    background-color: transparent;
    border: 1px solid #3B82F6;
    color: #3B82F6;
}

.form-button.secondary:hover {
    background-color: transparent;
    color: #3B82F6;
}

.auto-advance-message {
    font-size: 14px;
    color: #6B7280;
    font-style: italic;
}

.success-message {
    margin-top: 10px;
    padding: 10px;
    background-color: #D1FAE5;
    border: 1px solid #A7F3D0;
    color: #059669;
    border-radius: 4px;
    font-size: 14px;
}

@media only screen and (max-width: 767px) {
    .questions-div {
        width: 80%;
        padding: 50px 0% 80px;
        margin: 0 auto !important;
    }
    
    .button-group {
        flex-direction: column;
    }
    
    .address-form-row {
        flex-direction: row;
        gap: 8px;
        margin-bottom: 12px;
    }
    
    .address-field {
        flex: 2;
    }
    
    .apt-field {
        flex: 1;
    }
    
    .city-field {
        flex: 1;
    }
    
    .state-field {
        flex: 1;
    }
    
    .zip-field {
        flex: 1;
    }
    
    /* Ensure inputs don't overflow on mobile */
    .address-form-row input,
    .address-form-row select {
        font-size: 14px;
        padding: 8px 6px;
    }
}
@media only screen and (max-width: 767px) {
    .questions-div[data-v-20d89714] {
        width: 93%;
        padding: 50px 0% 80px;
        margin: 0 auto !important;
    }
}

/* Fix header being cut off by fixed navbar */
.afterreport_section {
    padding-top: 80px;
}

/* Fix loading overlay z-index to appear above navbar */
.loading-overlay2 {
    z-index: 9999999 !important;
}

</style>